<template>
    <v-row
        :class="['g1 sidebar_block px-5 ml-auto']"
        no-gutters
        justify="center"
        align="center"
        style="max-width: 250px; width: 100%"
    >
        <v-col>
            <template v-if="!appStoreDialogFlags.isWaitingList()">
                <v-row
                    no-gutters
                    class="flex-nowrap mb-3 d-flex"
                    align="center"
                >
                    <v-col class="mr-2 shrink d-flex">
                        <icon
                            size="20"
                            color="primary"
                            icon="BookText"
                        />
                    </v-col>
                    <v-col
                        class="primary--text body-2 cursor-pointer d-flex align-center"
                    >
                        <a :href="`/api/help_link/app_${appStoreDialogState.appData.name}`" target="_blank">
                            {{ $t('How to set up') }}
                        </a>
                    </v-col>
                </v-row>
                <v-divider class="mb-3 mt-4 v-divider g2"/>
            </template>
            <template v-if="appStoreDialogFlags.canActivateApp()">
                <v-row no-gutters>
                    <v-col>
                        <primary-button
                            v-if="requireElitePlan"
                            :disabled="!appStoreDialogFlags.canManageAccount()"
                            color="main"
                            class="inverted--text"
                            @click="onUpgradeBundle">
                            {{ $t('Get elite plan') }}
                        </primary-button>

                        <primary-button
                            v-else
                            :disabled="!appStoreDialogFlags.canManageAccount()"
                            @click="appStoreDialogActions.install">
                            {{ strings.activate }}
                        </primary-button>

                        <div v-if="!appStoreDialogFlags.canManageAccount()" class="caption g4--text">
                            {{ $t('Only administrators can activate the app') }}
                        </div>

                    </v-col>
                </v-row>
            </template>
            <template v-if="appStoreDialogFlags.isWaitingList() && isActivated">
                <v-row
                    no-gutters
                >
                    <v-col class="d-flex align-center">
                        <icon icon="Check" color="royal-blue"/>
                        <div class="ml-3 subtitle-2">
                            {{ $t('You are in the waiting list') }}
                        </div>

                    </v-col>
                </v-row>
            </template>
            <v-row
                v-if="appStoreDialogFlags.isWaitingList()"
                no-gutters
            >
                <div class="body-2 mt-3 g4--text">{{ $t('We onboard all applicants one by one') }}</div>
            </v-row>
            <template v-if="isActivated">
                <v-row class="d-flex">
                    <v-col v-if="!appStoreDialogFlags.isWaitingList()" class="shrink pr-2 pb-0" style="margin-top:-3px;">
                        <v-icon
                            color="tretiary"
                            size="20"
                        >
                            mdi-check-circle
                        </v-icon>
                    </v-col>
                    <v-col class="pb-0">
                        <v-row class="subtitle-2" v-if="!appStoreDialogFlags.isWaitingList()">
                            <span v-if="isConnected">{{ $t('Connected') }}</span>
                            <span v-else>{{ $t('Activated') }}</span>
                        </v-row>

                        <v-row class="connected-primary-info" v-if="connectedCompanyName">{{ connectedCompanyName }}</v-row>
                        <v-row class="connected-secondary-info" v-if="connectedEmail">{{ connectedEmail }}</v-row>
                        <v-row class="connected-secondary-info" v-else-if="activated_at">{{ activated_at }}</v-row>
                        <v-row class="connected-primary-info" :class="appStoreDialogFlags.isWaitingList() ? 'ml-0' : ''">
                            <v-btn
                                text
                                plain
                                depressed
                                x-small
                                :ripple="false"
                                :loading="loading['disconnectOrDeactivateFeature']"
                                @click="disconnectOrDeactivate"
                                color="pink"
                                class="connected-primary-info no-bg-color px-0 py-0"
                            >
                                <span v-if="isConnected">{{ strings.disconnect }}</span>
                                <span v-else>{{ strings.deactivate }}</span>
                            </v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </template>
        </v-col>
    </v-row>
</template>

<script>
import {$t} from "@/i18n";
import {computed} from "@vue/composition-api";
import {formatDate} from '@/plugins/formatting'
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import {APP_STORE_APP_TYPES} from '@/helpers/constants'
import LoadingModule from "@/store/modules/loading";
import AccountModule from '@/store/modules/account'
import {getManifestData} from "../../views/AppStore/app-store-manifest";
import DialogModule from "../../store/modules/dialog";

export default {
    name: "AppStoreDialogSidebar",
    setup(props, ctx) {
        const {isAccountElite} = AccountModule()
        const {closeDialog} = DialogModule();
        const {appStoreDialogState, appStoreDialogFlags, appStoreDialogGetters, appStoreDialogActions} = appStoreDialog()

        const {loading} = LoadingModule();
        const appData = appStoreDialogState.appData

        const selectedAccount = computed(() => {
            return appStoreDialogGetters.getSelectedCompany()
        })

        const requireElitePlan = computed(() => {
            const company_id = appStoreDialogGetters.getSelectedCompany().id
            const is_elite_or_better = isAccountElite(company_id)
            const is_waiting_list = appStoreDialogFlags.isWaitingList()
            const is_elite_app = !!getManifestData(appStoreDialogState.appData.name, 'isElite')

            console.debug('requireElitePlan', 'is_elite_or_better=', is_elite_or_better, 'is_waiting_list=', is_waiting_list, 'is_elite_app=', is_elite_app)

            if (is_elite_or_better) return false
            if (is_waiting_list) return false

            return is_elite_app
        })
        const activated_at = computed(() => {
            const settings = appStoreDialogGetters.getCurrentFeatureSettings()
            return settings ? formatDate(settings.activated_at) : null
        })

        const connectedEmail = computed(() => {
            const settings = appStoreDialogGetters.getCurrentFeatureSettings()
            return settings && settings.data ? settings.data.connection_email : null
        })

        const connectedCompanyName = computed(() => {
            const settings = appStoreDialogGetters.getCurrentFeatureSettings()
            return settings && settings.data ? settings.data.company_name : null
        })

        const showConnectAndDisconnect = computed(() => {
            return appData ? [APP_STORE_APP_TYPES.QUICKBOOKS,
                APP_STORE_APP_TYPES.XERO,
                APP_STORE_APP_TYPES.ECONOMIC,
                APP_STORE_APP_TYPES.TRIPLETEX
            ].includes(appData.name) : false
        })

        const isConnected = computed(() => {
            const settings = appStoreDialogGetters.getCurrentFeatureSettings()
            if (!settings.data) {
                return false
            }

            return settings ? settings.data.refresh_token || settings.data.agreement_grant_token || settings.data.employee_token : false
        })

        const strings = computed(() => {
            const is_waiting_list = appStoreDialogFlags.isWaitingList()
            return {
                activate: is_waiting_list ? $t('Join waiting list') : $t('Activate'),
                deactivate: is_waiting_list ? $t('Unsubscribe from waiting list') : $t('Deactivate app'),
                disconnect: $t('Disconnect')
            }
        })

        const isActivated = computed(() => {
            const waiting_list_apps = selectedAccount.value.data.waiting_list_apps ? selectedAccount.value.data.waiting_list_apps : []
            if (appStoreDialogFlags.isWaitingList() && waiting_list_apps.includes(appData.feature_id)) {
                return true
            }

            return appStoreDialogFlags.canDeactivateApp()
        })

        const disconnectOrDeactivate = async () => {
            if (isConnected.value) {
                await appStoreDialogActions.disconnect()
            } else {
                await appStoreDialogActions.deactivate()
            }
        }

        const onUpgradeBundle = () => {
            ctx.root._router.push({
                name: "subscription_choose_plan",
                params: {
                    id: selectedAccount.value.id,
                    set_plan_name: "elite",
                }
            });
            closeDialog()
        };

        return {
            appStoreDialogFlags,
            activated_at,
            appStoreDialogActions,
            appStoreDialogGetters,
            appStoreDialogState,
            strings,
            isActivated,
            connectedEmail,
            connectedCompanyName,
            isConnected,
            showConnectAndDisconnect,
            disconnectOrDeactivate,
            loading,
            selectedAccount,
            onUpgradeBundle,
            getManifestData,
            isAccountElite,
            requireElitePlan,
        }
    }
};
</script>
<style scoped lang="scss">
.v-divider {
    margin-left: -20px;
    max-width: calc(100% + 40px);
    width: 250px;
}

.connected-primary-info {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    text-transform: none;
}

.connected-secondary-info {
    font-weight: 400;
    font-size: 14px;
    opacity: 0.4;
    line-height: 20px;
    letter-spacing: -0.15px;
}

.no-bg-color::before {
    background-color: transparent;
}
</style>
